module.exports = __webpack_public_path__ + "static/bg_white-8a575e20d8b5f5ec943142bea2615f36.png";